import Vue from 'vue';
import Router from 'vue-router';

import { TweenLite, ScrollToPlugin, Power2 } from "gsap/all"; //eslint-disable-line

import Index from '@/views/Index';
import Event from '@/views/Event';

import { fetchData } from '@/scripts/utils';
import store from '../store';


Vue.use(Router);

const router = new Router({
  mode: 'history',

  routes: [
    {
      path: '/:lang(it|en)',
      name: 'home',
      component: Index,
    },
    {
      path: '/',
      redirect: '/it',
    },
    {
      path: '/:lang(it|en)/:event',
      name: 'event',
      component: Event,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const element = document.querySelector('.app__wrapper');
  if (element !== null) {
    element.classList.add('bg-hide');
    TweenLite.to(element, 1, { scrollTo: { y: 0, autoKill: false } }); //eslint-disable-line
  }

  store.state.lang = to.params.lang;
  fetchData(to, from, next);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js